import React from "react";
import { observer } from "mobx-react";
import OrderList from "./OrderList";
import { getSelectedOrderId } from "modules/orders-manage/details/OrderDetailsTabsPage";
import styles from "./OrderListWrapper.module.scss";
import { OrderListType, OrderListSnapshotType } from "../models/order-list";
import { IDisposer, onSnapshot } from "mobx-state-tree";
import { canReadOrder } from "../functionalities";
import { can } from "modules/session/auth/access";
import { routes } from "modules/common/routes";
import { ClientFunctionalities } from "modules/agents/clients/models/client";
import { withNavigation, NavigationProps, type Location } from "modules/common/components/routing/withNavigation";

class Wrapper extends React.Component<OrderListWrapperProps & NavigationProps, OrderListState> {
  private list = React.createRef<HTMLDivElement>();
  private disposer?: IDisposer;

  constructor(props: OrderListWrapperProps & NavigationProps) {
    super(props);

    this.state = {
      orderId: getSelectedOrderId(props.location.pathname),
    };
  }

  // подписки — при монтировании: снимаются они при размонтировании, а React вправе
  // смонтировать экземпляр повторно или выбросить его, не смонтировав
  componentDidMount() {
    const { store } = this.props;

    this.disposer = onSnapshot(store, this.hadleVisibility);
  }

  componentDidUpdate(prevProps: NavigationProps) {
    // смена адреса приходит новым location в пропах
    if (prevProps.location !== this.props.location) {
      this.onLocationChanged(this.props.location);
    }
  }

  onLocationChanged = (location: Location) => {
    const orderId = getSelectedOrderId(location.pathname);
    this.setState({ orderId });
    this.props.store.toggleVisibility(false);
  };

  componentWillUnmount() {
    this.disposer?.();
  }

  hadleVisibility = (snapshot: OrderListSnapshotType) => {
    if (snapshot.visible && this.list.current) {
      const element: HTMLInputElement | null = this.list.current.querySelector(".order-list-filter input");
      element && !this.props.isMobile && element.focus();
    }
  };

  render() {
    const { store, access } = this.props;

    const style: React.CSSProperties = {
      width: store.visible ? "320px" : "0px",
      // opacity: store.visible ? 1 : 0,
    };

    return (
      <div className={`order-list-wrapper ${styles.wrapper}`} ref={this.list}>
        <OrderList
          canRead={canReadOrder(access)}
          orderRoute={
            can(ClientFunctionalities.CLIENTS_USER_ACCESS, access) ? routes.orders.workResult : routes.orders.details
          }
          onOrderSelected={store.setLastestProjectId}
          selectedOrder={this.state.orderId}
          store={store}
          style={style}
        />
      </div>
    );
  }
}

export const OrderListWrapper = withNavigation(observer(Wrapper));

interface OrderListState {
  orderId: string;
}

interface OrderListWrapperProps {
  store: OrderListType;
  access: string[];
  isMobile: boolean;
}
